export default __webpack_public_path__ + "static/media/chevronLeft.0c333be5.svg";